import React from 'react';

import { PreferencesProfileVisibility } from '../components/Preferences/PreferencesProfileVisibility';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type ProfileVisibilityPreferencesPageProps = {
  name?: string;
};

export const ProfileVisibilityPreferencesPage = ({
  name = 'PROFILE_VISIBILITY_PREFERENCES_PAGE',
}: ProfileVisibilityPreferencesPageProps) => {
  useDocumentTitle('Preferences');
  return (
    <div data-test={name}>
      <PreferencesProfileVisibility />
    </div>
  );
};
